import React from 'react';
import { CalendarClock, Video, MonitorPlay, ArrowRight, Check, ShieldCheck } from 'lucide-react';

const included = [
  '4 aulas ao vivo com Adeilson Chagas',
  'Mais de 20 aulas gravadas na plataforma',
  'Acesso completo por 1 ano',
  'Suporte direto para tirar dúvidas',
  'Comunidade exclusiva de alunos',
  'Certificado oficial WING Academy Brasil'
];

const Pricing = () => {
  const scrollToLead = (e) => {
    e.preventDefault();
    const el = document.querySelector('#inscricao');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section
      id="precos"
      data-testid="pricing-section"
      className="relative overflow-hidden bg-yellow-400 py-16 md:py-24"
    >
      {/* Giant translucent "WING" watermark in the background */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none">
        <span
          className="text-[22vw] md:text-[18vw] font-black text-white/10 tracking-tighter leading-none"
          style={{ fontFamily: "'Arial Black', sans-serif" }}
        >
          WING
        </span>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Top eyebrow */}
          <div className="text-center mb-6 md:mb-8">
            <div className="inline-flex items-center gap-2 bg-black/90 text-yellow-400 px-5 py-2 rounded-full shadow-lg">
              <CalendarClock className="w-4 h-4" />
              <span className="font-bold text-xs md:text-sm tracking-widest uppercase">
                Nova turma — Em breve
              </span>
            </div>
          </div>

          {/* Title */}
          <h2
            data-testid="pricing-title"
            className="text-center text-[2rem] leading-[1.05] sm:text-5xl md:text-6xl font-black text-black mb-4 md:mb-6"
          >
            GARANTA
            <br className="sm:hidden" />
            <span className="bg-black text-yellow-400 px-3 inline-block mt-2 md:mt-3 md:ml-3">
              SUA VAGA
            </span>
          </h2>

          <p className="text-center text-black/80 text-sm sm:text-base md:text-xl font-medium max-w-2xl mx-auto mb-8 md:mb-12 px-1">
            Mentoria híbrida: <span className="font-bold">4 aulas ao vivo + mais de 20 aulas gravadas</span> para
            você dominar a Console WING de uma vez por todas.
          </p>

          {/* Card */}
          <div
            data-testid="pricing-card"
            className="relative bg-gray-900 rounded-3xl p-6 md:p-10 shadow-[0_30px_80px_-20px_rgba(0,0,0,0.5)]"
          >
            {/* Top stats row */}
            <div className="grid grid-cols-3 gap-2 md:gap-4 mb-7 md:mb-10">
              <div className="text-center border-r border-white/10 pr-2 md:pr-3">
                <div className="flex items-center justify-center w-9 h-9 md:w-12 md:h-12 rounded-xl bg-yellow-400/10 border border-yellow-400/30 mx-auto mb-2">
                  <Video className="w-4 h-4 md:w-6 md:h-6 text-yellow-400" />
                </div>
                <div className="text-white font-black text-lg md:text-2xl">4</div>
                <div className="text-gray-400 text-[10px] md:text-xs uppercase tracking-wider mt-0.5">
                  Aulas ao vivo
                </div>
              </div>
              <div className="text-center border-r border-white/10 px-2 md:px-3">
                <div className="flex items-center justify-center w-9 h-9 md:w-12 md:h-12 rounded-xl bg-yellow-400/10 border border-yellow-400/30 mx-auto mb-2">
                  <MonitorPlay className="w-4 h-4 md:w-6 md:h-6 text-yellow-400" />
                </div>
                <div className="text-white font-black text-lg md:text-2xl">20+</div>
                <div className="text-gray-400 text-[10px] md:text-xs uppercase tracking-wider mt-0.5">
                  Aulas gravadas
                </div>
              </div>
              <div className="text-center pl-2 md:pl-3">
                <div className="flex items-center justify-center w-9 h-9 md:w-12 md:h-12 rounded-xl bg-yellow-400/10 border border-yellow-400/30 mx-auto mb-2">
                  <CalendarClock className="w-4 h-4 md:w-6 md:h-6 text-yellow-400" />
                </div>
                <div className="text-white font-black text-lg md:text-2xl">1 ano</div>
                <div className="text-gray-400 text-[10px] md:text-xs uppercase tracking-wider mt-0.5">
                  De acesso
                </div>
              </div>
            </div>

            {/* Price */}
            <div className="text-center mb-8 md:mb-10" data-testid="pricing-price">
              <div className="text-gray-400 text-sm md:text-base mb-1">Investimento</div>
              <div className="text-white font-black text-4xl md:text-5xl leading-none">
                <span className="text-yellow-400">Em breve</span>
              </div>
              <div className="inline-flex items-center gap-2 mt-3 text-green-400 text-xs md:text-sm font-semibold">
                <ShieldCheck className="w-4 h-4" />
                Pagamento seguro via Mercado Pago
              </div>
            </div>

            {/* Included list */}
            <div className="mb-8 md:mb-10">
              <h3 className="text-white font-bold text-lg md:text-xl mb-5 text-center">
                Sua inscrição inclui:
              </h3>
              <ul className="grid sm:grid-cols-2 gap-3 md:gap-4 max-w-2xl mx-auto">
                {included.map((b, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full bg-yellow-400 flex items-center justify-center mt-0.5">
                      <Check className="w-3 h-3 md:w-4 md:h-4 text-black" strokeWidth={3} />
                    </span>
                    <span className="text-gray-200 text-sm md:text-[15px]">{b}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* CTA */}
            <a
              href="#inscricao"
              onClick={scrollToLead}
              data-testid="pricing-cta-btn"
              className="btn-shine group block w-full bg-green-500 hover:bg-green-600 text-white text-center px-6 py-4 md:py-5 rounded-xl font-black text-lg md:text-xl tracking-wide transition-all duration-300 hover:scale-[1.02] shadow-[0_20px_40px_-10px_rgba(16,185,129,0.5)]"
            >
              <span className="flex items-center justify-center gap-2">
                GARANTIR MINHA VAGA
                <ArrowRight className="w-5 h-5 md:w-6 md:h-6 group-hover:translate-x-1 transition-transform" />
              </span>
            </a>

            {/* Reassurance line */}
            <p className="mt-5 text-center text-gray-400 text-xs md:text-sm">
              Garantia dupla: entrevista individual antes do pagamento + devolução de 100% em até 7 dias a partir da primeira aula ao vivo.
            </p>
          </div>

          {/* Bottom urgency */}
          <div className="mt-8 md:mt-10 text-center">
            <p className="text-black font-bold text-sm md:text-base">
              ⚡ Vagas limitadas para garantir atendimento de qualidade nas aulas ao vivo
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
